import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxsModule } from '@ngxs/store';
import { IconModule } from '@x/common/icon';
import { OperationModule } from '@x/common/operation';
import { ShopErrorModule } from '@x/ecommerce-shop/app/core/shop-error/shop-error.module';
import { IconUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/icon-ui/icon-ui.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { WishlistActionComponent } from '@x/ecommerce-shop/app/core/whishlist/components/whishlist/wishlist-action.component';
import { WishlistState } from '@x/ecommerce-shop/app/core/whishlist/state/wishlist.state';

@NgModule({
  declarations: [WishlistActionComponent],
  imports: [
    CommonModule,
    NgxsModule.forFeature([WishlistState]),
    IconModule,
    IconUiModule,
    MatTooltipModule,
    MatButtonModule,
    UtilsModule,
    ShopErrorModule,
    OperationModule,
  ],
  exports: [WishlistActionComponent],
})
export class WishlistModule {}
